import { useEffect, useRef } from 'react'

export const useDropdownHandler = (
  isExpanded: boolean,
  searchQuery: string,
  setShowResults: (show: boolean) => void,
  setIsExpanded: (expanded: boolean) => void,
  setSearchQuery?: (query: string) => void,
) => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!isExpanded) return

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      const isClickInsideDropdown = dropdownRef.current?.contains(target)
      const isClickInsideInput = inputRef.current?.contains(target)

      if (!isClickInsideDropdown && !isClickInsideInput) {
        setShowResults(false)
        if (!searchQuery) {
          setIsExpanded(false)
        }
      }
    }

    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setShowResults(false)
        setIsExpanded(false)
        if (setSearchQuery) {
          setSearchQuery('')
        }
      }
    }

    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('keydown', handleEscapeKey)
    }, 0)

    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeKey)
    }
  }, [isExpanded, searchQuery, setShowResults, setIsExpanded, setSearchQuery])

  return { dropdownRef, inputRef }
}
